import { Textarea as FlowbiteTextarea, Label } from 'flowbite-react';
import type { FunctionComponent } from 'react';

import { labelSizes, labelVariants } from '../utils';
import type { TextAreaProps } from './types';

const customTheme = {
  base: 'block w-full max-h-[300px] min-h-[100px] rounded-lg border text-base disabled:cursor-not-allowed scrollbar-rounded disabled:opacity-50 dark:bg-bg_dark dark:text-n700_text_dark_mode',
  colors: {
    default:
      'border placeholder-n400_input_stroker !border-n200_background focus:!ring-n400_input_stroker focus:!border-n400_input_stroker',
    error: '!border-brand focus:!border-brand focus:!ring-brand'
  },
  withShadow: {
    on: 'shadow-sm dark:shadow-sm-light',
    off: ''
  }
};

export const Textarea: FunctionComponent<TextAreaProps> = ({
  label,
  id,
  labelStyle = 'normal',
  labelSize = 'medium',
  color = 'default',
  className,
  error = '',
  ...props
}) => {
  return (
    <>
      {label && (
        <Label htmlFor={id} className={`block mb-2 text-base ${labelVariants[labelStyle]} ${labelSizes[labelSize]}`}>
          {label}
        </Label>
      )}

      <FlowbiteTextarea
        {...props}
        color={error ? 'error' : color}
        theme={{ ...customTheme, base: `${customTheme.base} ${className}` }}
        maxLength={10000}
      />
      {error && <p className='!text-brand text-xs mt-1'>{error}</p>}
    </>
  );
};
